require('./brokerLegalConfirmation.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');

//@core
const { FormattedText, formatText } = require('core/i18n').i18n;

//@components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');

// @ constants
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');

class BrokerLegalConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.refreshEmailAddressHandler = this.refreshEmailAddressHandler.bind(this);
        this.sendMailHandler = this.sendMailHandler.bind(this);
    }

    componentWillUnmount() {
        const { resetMailState } = this.props;
        resetMailState();
    }

    handleValueChange(value) {
        const { onYesNoOptionChange } = this.props;
        onYesNoOptionChange && onYesNoOptionChange(value);
    }

    refreshEmailAddressHandler() {
        const { refreshEmailAddress, onYesNoOptionChange } = this.props;
        onYesNoOptionChange && onYesNoOptionChange(SELECTED_VALUES.EMPTY);
        refreshEmailAddress();
    }

    sendMailHandler(params) {
        const { sendMail, onYesNoOptionChange } = this.props;

        onYesNoOptionChange && onYesNoOptionChange(SELECTED_VALUES.EMPTY);
        sendMail(params);
    }

    buildProductDescription() {
        const { legalDisclaimerProductDescription } = this.props;
        
        let productDescription = null;

        if (legalDisclaimerProductDescription) {
            productDescription = (
                <BlockInfo extraClass="broker-legal-confirmation__block-info">
                    {legalDisclaimerProductDescription}
                </BlockInfo>
            );
        }

        return productDescription;
    }

    buildMandatoryReading() {
        const { legalDisclaimerMandatoryReading } = this.props;

        let mandatoryReading = null;

        if (legalDisclaimerMandatoryReading) {
            mandatoryReading = (
                <div className="broker-legal-confirmation__mandatory-reading-section">
                    <i className="broker-legal-confirmation__mandatory-reading-icon" />
                    <div className="broker-legal-confirmation__mandatory-reading-content">
                        {legalDisclaimerMandatoryReading}
                    </div>
                </div>
            );
        }

        return mandatoryReading;
    }

    buildImportantInformation() {
        const { importantInformation } = this.props;

        let importantInfo = null;

        if (importantInformation) {
            importantInfo = (
                <BlockInfo extraClass="broker-legal-confirmation__block-info">
                    {importantInformation}
                </BlockInfo>
            );
        }

        return importantInfo;
    }

    buildDocumentLinks() {
        const { legalDisclaimerDocumentLinks } = this.props;

        let documentLinks = null;

        if (legalDisclaimerDocumentLinks) {
            documentLinks = (
                <BlockInfo extraClass="broker-legal-confirmation__block-info no-print-out">
                    {legalDisclaimerDocumentLinks}
                </BlockInfo>
            );
        }

        return documentLinks;
    }

    buildYesNoQuestion() {
        const { legalDisclaimerQuestion, selectedYesNoOption, immPreContractualMail, refreshEmailAddressError } = this.props;

        let yesNoQuestion = null;

        if (legalDisclaimerQuestion) {
            const optionsDisabled = !immPreContractualMail.get('mailSent') || !!refreshEmailAddressError;

            yesNoQuestion = (
                <BlockInfo extraClass="broker-legal-confirmation__block-info no-print-out">
                    {legalDisclaimerQuestion}
                    <RadioButtonGroup
                        name="brokerLegalConfirmationYesNo"
                        idPrefix="brokerLegalConfirmationYesNo"
                        selectedValue={selectedYesNoOption}
                        onChange={this.handleValueChange}
                        className="broker-legal-confirmation__radio-group"
                    >
                        <RadioButton label={formatText('brokerLegalConfirmation-yesValue')} value={SELECTED_VALUES.YES} disabled={optionsDisabled} className="broker-legal-confirmation__radio"/>
                        <RadioButton label={formatText('brokerLegalConfirmation-noValue')} value={SELECTED_VALUES.NO} disabled={optionsDisabled} className="broker-legal-confirmation__radio"/>
                    </RadioButtonGroup>
                </BlockInfo>
            );
        }

        return yesNoQuestion;
    }

    buildAnswerOfYesNoQuestion() {
        const { selectedYesNoOption, legalDisclaimerYesAnswer, legalDisclaimerNoAnswer } = this.props;

        let answerOfYesNoQuestion = null;

        if (selectedYesNoOption === SELECTED_VALUES.YES) {
            answerOfYesNoQuestion = (
                <BlockInfo extraClass="broker-legal-confirmation__block-info no-print-out">
                    {legalDisclaimerYesAnswer}
                </BlockInfo>
            );
        } else if (selectedYesNoOption === SELECTED_VALUES.NO) {
            answerOfYesNoQuestion = (
                <BlockInfo extraClass="broker-legal-confirmation__block-info no-print-out">
                    {legalDisclaimerNoAnswer}
                </BlockInfo>
            );
        }

        return answerOfYesNoQuestion;
    }

    render() {
        const {
            className,
            titleKey,
            clientEmailAddress,
            refreshEmailAddressError,
            sendMailParams,
            immPreContractualMail,
            exAntCost,
        } = this.props;

        const brokerLegalConfirmationClass = classNames('broker-legal-confirmation', { [className]: !!className });
        const title = titleKey ? (<FormattedText value={titleKey}/>) : (<FormattedText value="brokerLegalConfirmation-title"/>);

        const productDescription = this.buildProductDescription();
        const mandatoryReading = this.buildMandatoryReading();
        const documentLinks = this.buildDocumentLinks();
        const yesNoQuestion = this.buildYesNoQuestion();
        const answerOfYesNoQuestion = this.buildAnswerOfYesNoQuestion();
        const importantInformation = this.buildImportantInformation();
        return (
            <div className={brokerLegalConfirmationClass}>
                <h1 className="broker-legal-confirmation__title">
                    {title}
                </h1>
                {productDescription}
                {mandatoryReading}
                {importantInformation}
                {documentLinks}
                <div className="broker-legal-confirmation__send-mail no-print-out">
                    <PreContractualMailInfo
                        email={clientEmailAddress}
                        requestProfile={this.refreshEmailAddressHandler}
                        profileError={refreshEmailAddressError}
                        sendEmail={this.sendMailHandler}
                        sendMailParams={sendMailParams}
                        preContractualMail={immPreContractualMail}
                        showLegalText={false}
                    />
                </div>
                {exAntCost}
                {yesNoQuestion}
                {answerOfYesNoQuestion}
            </div>
        );
    }
}

BrokerLegalConfirmation.propTypes = {
    className: PropTypes.string,
    titleKey: PropTypes.string,
    legalDisclaimerProductDescription: PropTypes.node,
    legalDisclaimerMandatoryReading: PropTypes.node,
    legalDisclaimerDocumentLinks: PropTypes.node,
    clientEmailAddress: PropTypes.string.isRequired,
    refreshEmailAddress: PropTypes.func.isRequired,
    refreshEmailAddressError: PropTypes.string,
    sendMail: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    resetMailState: PropTypes.func.isRequired,
    legalDisclaimerQuestion: PropTypes.node,
    selectedYesNoOption: PropTypes.string,
    onYesNoOptionChange: PropTypes.func,
    sendDocumentBulletin: PropTypes.func,
    legalDisclaimerYesAnswer: PropTypes.node,
    legalDisclaimerNoAnswer: PropTypes.node,
    exAntCost: PropTypes.node,
};

module.exports = BrokerLegalConfirmation;
